export default "__VITE_ASSET__BtAXkBhP__"